export default "__VITE_ASSET__$8271baP__"